import React from 'react';
import '../css/ImageResizeWarningStyle.css';

const ImageResizeWarning = function(props) {
    return  <div className='image-resize-warning'>
                <p><b>Note :</b> Images resized here are automatically adjusted to a % of the screen's size.
                iPads and mobile devices will have scaled down images, as seen in live preview.
                The desktop version of the images are shown only in the  text editor, when the live preview is closed.</p>
            </div>
}
export default ImageResizeWarning;
